import styled from "styled-components";

export const OperatorSidePanelWrapperStyled = styled.div`
  width: 544px;
  height: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  cursor: default;
  overflow-y: auto;
  border-right: 1px solid #d1d1d1;
`;

export const MissionOperatorBoardStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
`;

export const PickerPaddingStyled = styled.div`
  padding: 32px 32px 21px;
  background: #f4f4f4;
  margin-bottom: 32px;
`;

export const LoadingStyled = styled.div`
  height: 41px;
`;

/* Station operator view */
export const OperatorPanelWrapperStyled = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;

  > div:last-child {
    flex-basis: 400px;
  }
`;

export const OperatorInspectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 660px;
  max-width: 750px;
`;

export const SubtitleWrapperStyled = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  h3 {
    font-size: 24px;
    color: #606060;
    font-weight: 500px;
  }
`;
export const SemanticMapPickerStyled = styled.div`
  width: 500px;
  padding-left: 12px;
`;

export const EmptyErrorStyled = styled.div`
  color: red;
  font-weight: 500;
`;
